export default "/_next/static/chunks/fonts/HK Grotesk Bold-b69ad49e00be0b7e4a4fa38896cb87f0.otf";